import { useQuery } from "@tanstack/react-query";
import { Text, Button, H4, Card, Box, Spinner } from "@adfenix/alexandria";
import { useNavigate } from "react-router-dom";
import { TemplateList } from "./list/TemplateList";
import { toast } from "react-toastify";
import styled from "styled-components";
import { TemplateService } from "@adfenix/types";
import { getTemplatesForOwner } from "api/services/templateService";

interface Props {
  ownerType: TemplateService.SubjectType;
  subjectType: TemplateService.SubjectType;
  ownerId: string;
}

export const templatesForOwnerKey = "getTemplatesForOwner";

const StyledCard = styled(Card)`
  padding: 0;
  position: relative;
`;

export const TemplatesForSubject = ({
  ownerType,
  ownerId,
  subjectType
}: Props) => {
  const navigate = useNavigate();

  const { data, error, isLoading } = useQuery(
    [templatesForOwnerKey, ownerId],
    () => getTemplatesForOwner(ownerType, ownerId),
    {
      select: data => ({
        facebook: data.facebook.filter(x => x.subjectType === subjectType),
        instagram: data.instagram.filter(x => x.subjectType === subjectType),
        twitter: data.twitter.filter(x => x.subjectType === subjectType)
      })
    }
  );

  if (isLoading) {
    return <Spinner />;
  }

  if (!data || !data.facebook) {
    return (
      <Text>
        {`Couldn't find any existing templates. Please create a new one.`}
      </Text>
    );
  }

  if (error) {
    toast.error("Failed to fetch templates");
    return null;
  }

  return (
    <StyledCard id={`templates-for-subject-${subjectType}`}>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        p="m"
      >
        <H4 style={{ textTransform: "capitalize" }}>{subjectType}</H4>
        <Button
          logLabel="create-new-template-button"
          onClick={() => {
            navigate(`./create/${subjectType}`);
          }}
        >
          + Create new
        </Button>
      </Box>

      <TemplateList
        channel="facebook"
        templates={data.facebook}
        subjectType={subjectType}
      />
      <TemplateList
        channel="instagram"
        templates={data.instagram}
        subjectType={subjectType}
      />
    </StyledCard>
  );
};
